import { addTransitionType, startTransition } from "react";
import { Config, RouterProps } from "router2/lib/types";

import { Home } from "~/ui/page/Home";
import { Like } from "~/ui/page/Like";
import { MyPage } from "~/ui/page/MyPage";
import { NotFound } from "~/ui/page/NotFound";
import { Register } from "~/ui/page/Register";
import { Search } from "~/ui/page/Search";
import { Setting } from "~/ui/page/Setting";
import { SignIn } from "~/ui/page/SignIn";
import { ThridPartyRegister } from "~/ui/page/ThirdPartyRegister";
import { User } from "~/ui/page/User";
import { WebHome } from "~/ui/page/web/WebHome";
import { WebLike } from "~/ui/page/web/WebLike";
import { WebMyPage } from "~/ui/page/web/WebMyPage";
import { WebRegister } from "~/ui/page/web/WebRegister";
import { WebSearch } from "~/ui/page/web/WebSearch";
import { WebSetting } from "~/ui/page/web/WebSetting";
import { WebSignIn } from "~/ui/page/web/WebSignIn";
import { WebThirdPartyRegister } from "~/ui/page/web/WebThirdPartyRegister";
import { WebUser } from "~/ui/page/web/WebUser";

const scroll = new Map<string, number>();

/** 페이지 push 네비게이션임을 <ViewTransition>에 알리는 트랜지션 타입 */
export const PAGE_PUSH_TRANSITION_TYPE = "navigation-push";
/** PAGE_PUSH_TRANSITION_TYPE 일 때 적용되는 view-transition-class (index.css) */
export const PAGE_PUSH_TRANSITION_CLASS = "page-push";

export const config: Config = {
  on: {
    afterBack: ({ current }) => {
      window.scrollTo({ top: scroll.get(current.pathname) ?? 0 });
    },
    afterForward: () => {
      window.scrollTo({ top: 0 });
    },
    afterPush: () => {
      window.scrollTo({ top: 0 });
    },
    afterReplace: ({ current }) => {
      window.scrollTo({ top: scroll.get(current.pathname) ?? 0 });
    },
    beforeBack: ({ prev }, next) => {
      scroll.set(prev.pathname, window.scrollY);
      next();
    },
    beforePush: ({ prev }, next) => {
      scroll.set(prev.pathname, window.scrollY);
      if (prev.pathname.startsWith("/web")) {
        next();
        return;
      }
      startTransition(() => {
        addTransitionType(PAGE_PUSH_TRANSITION_TYPE);
        next();
      });
    },
    beforeReplace: ({ prev }, next) => {
      scroll.set(prev.pathname, window.scrollY);
      next();
    },
  },
};

export const routes: RouterProps["routes"] = {
  "/": Home,
  "/404": NotFound,
  "/like": Like,
  "/my-page": MyPage,
  "/register": Register,
  "/search": Search,
  "/setting": Setting,
  "/sign-in": SignIn,
  "/third-party-register": ThridPartyRegister,
  "/user/:userId": User,
  "/web": WebHome,
  "/web/like": WebLike,
  "/web/my-page": WebMyPage,
  "/web/register": WebRegister,
  "/web/search": WebSearch,
  "/web/setting": WebSetting,
  "/web/sign-in": WebSignIn,
  "/web/third-party-register": WebThirdPartyRegister,
  "/web/user/:userId": WebUser,
};
